let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6NyeQ")).then(() => parcelRequire('4HxuJ'));